import { api, captureIdentity, isCurrentIdentity } from './client';
import type { AudioUrl, CallDetail, CallListItem, CallListQuery, PagedResult } from '../types/calls';

export const callsApi = {
  list: (query: CallListQuery) =>
    api.get<PagedResult<CallListItem>>('/calls', { params: query }).then((r) => r.data),

  get: (id: number) => api.get<CallDetail>(`/calls/${id}`).then((r) => r.data),

  audioUrl: (id: number) => api.get<AudioUrl>(`/calls/${id}/audio-url`).then((r) => r.data),

  /** Fetches the CSV as a blob (so the JWT header is sent) and triggers a download. */
  exportCsv: async (query: CallListQuery) => {
    const identity = captureIdentity();
    const res = await api.get('/calls/export', { params: query, responseType: 'blob' });
    if (!isCurrentIdentity(identity)) return;
    const url = URL.createObjectURL(res.data as Blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'calls.csv';
    a.click();
    URL.revokeObjectURL(url);
  },
};
